import { DataGridDataCell } from '@myosh/odin-components';
import DOMPurify from 'dompurify';
import dot from 'dot-object';
import type { RendererProps } from './renderer-registry';

const RichtextareaRenderer = ({ records, valuePath, columnWidth }: RendererProps) => {
  if (!valuePath) return null;

  let recordValue;
  for (let i = 0; i < records.length; i++) {
    recordValue = dot.pick(valuePath, records[i]);
    if (recordValue) break;
  }

  if (!recordValue) return null;

  const displayValue = DOMPurify.sanitize(recordValue, { USE_PROFILES: { html: true } });

  return displayValue ? <DataGridDataCell value={displayValue} width={columnWidth} renderAsInnerHTML /> : null;
};

export default RichtextareaRenderer;
